
import { Canvas, Group, Object as FabricObject, Rect, Line, Polygon } from "fabric";
import { CustomFabricObject, ShapeType, CustomGroup, CustomCanvas } from "@/types/fabric";
import { MeasurementService } from "@/services/measurement-service";

export const createMeasuredGroup = (
  canvas: Canvas,
  shape: FabricObject,
  measurements: FabricObject[],
  shapeType: ShapeType
): CustomGroup => {
  // Use the measurement service to create a group with measurements
  const group = MeasurementService.createMeasurementGroup(shape, measurements, canvas, shapeType);
  
  // If the shape has a custom name, use it for the group as well
  if ((shape as any).data?.name) {
    group.data = {
      ...group.data,
      name: (shape as any).data.name
    };
  }
  
  return group;
};

const updateMeasurements = (group: CustomGroup, canvas: Canvas) => {
  // Delegate to the measurement service
  MeasurementService.updateShapeMeasurements(group, canvas);
};

// New function to toggle measurement visibility across all groups
export const toggleMeasurementsVisibility = (
  canvas: CustomCanvas, 
  show: boolean
): void => {
  if (!canvas || !canvas.getObjects) return;
  
  // Update the canvas setting
  if (!canvas.data) {
    canvas.data = {};
  }
  canvas.data.showMeasurements = show;
  
  // Update all measurement elements
  canvas.getObjects().forEach(obj => {
    const group = obj as any;
    if (group.getObjects && group.data?.isMeasurementGroup) {
      group.getObjects().forEach((childObj: any) => {
        if (childObj.data?.type === 'measurement') {
          childObj.visible = show;
        }
      });
    }
  });
  
  canvas.renderAll();
};
